import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BaseInjectorService } from 'src/app/base/base-service.injector';
import { AppService } from 'src/app/app.service';
import { RapidtourService } from 'src/app/services/rapid-tour/rapidtour.service';
import { where } from '@angular/fire/firestore';

@Component({
    selector: 'app-rapid-obervations-list',
    templateUrl: './rapid-obervations-list.component.html',
    styleUrls: ['./rapid-obervations-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RapidObervationsListComponent extends BaseInjectorService implements OnInit {
  observation_list: any;
  fromPage:any;
  edit_flag:any;
  obs_length:any=0;
  private selectedObslist:any;
  isdataLoaded:boolean=false;
  constructor(private rapidtourService:RapidtourService,private modal: ModalController,private appService:AppService) {
    super();
  }

  async ngOnInit() {
    if(this.fromPage !='add-findings'){
      if(this.observation_list== undefined || this.observation_list.length == 0)
        this.isdataLoaded=true;
      else this.isdataLoaded=false;
      let currentRapid = await this.lhStorage.get("currentRapid");
      this.observation_list = await this.rapidtourService.getCurrentRapidTourObservationList(currentRapid.id);
      this.obs_length=(this.observation_list).length;
      this.observation_list.forEach(element => {
        element.readMore=false;
      });
    }
   }
  async editObservation(obs,fromRoute) {
      await this.overlayService.presentLoading(this.createLoaderOptions(this.translate.instant('APP_LOADING_LABEL')));
      const obsInfo = await this.lhFire.getDocument('observations', obs.id);
      obs = obsInfo.data();
      if (obs.icare_sync_status !== 'SYNCED') {
        this.overlayService.loading && await this.overlayService.dismissLoading();
        this.overlayService.presentToast(this.createToastOptions(this.translate.instant("SHIELD_OBSERVATION_LIST.SYNC_MESSAGE")));
        return;
      }
      let memberInfo = await this.lhFire.queryCollection(`observations/${obs.id}/actions`,where("action_number", "!=", ""))
      // let memberInfo = await this.lhFire.collection(`observations/${obs.id}/actions`).ref.where("action_number", "!=", "").get();
      const actions: any[] = []; 
      memberInfo.docs?.forEach((element: any) => {
        actions.push(element.data());
      });
      this.rapidtourService.isfromObservation=true;
      this.appService.editObservation.currentObservationInfo = obs;
      this.appService.editObservation.currentObservationActions = actions;
      if (obs.type == 'CVPC') {
        let questionnaireInfo = await this.lhFire.queryCollection(`observations/${obs.id}/questionnaire`,where("questionnaire_number", "!=", ""))
        // let questionnaireInfo = await this.lhFire.collection(`observations/${obs.id}/questionnaire`).ref.where("questionnaire_number", "!=", "").get();
        let quesdata: any = questionnaireInfo.docs[0].data();
        let questionnaire = { id: questionnaireInfo.docs[0].id, ...quesdata };
        this.appService.editObservation.currentObservationQuestionnaire = questionnaire;
      }else{
        this.appService.editObservation.currentObservationQuestionnaire = {};
      }
      if (obs.type == 'HAZ') {
        this.appService.setHazImageData(actions[0].images);
      } 
        
      this.appService.editObservation.currentActivityTime = this.moment().toISOString();
      await this.lhStorage.set('editObservation', this.appService.editObservation);
      this.overlayService.loading && await this.overlayService.dismissLoading();
      if (obsInfo.data()) {
        this.closeModal();

        if (obs.type == "VPC") {
          this.router.navigate(['/vpc-haz'], { queryParams: { fromPage: 'VPC', fromRoute: fromRoute, tripTime: obs.duration_of_vpc, mode: "edit", obsId: obs.id } });
        } else if (obs.type == "CVPC") {
          this.router.navigate(['/vpc-haz'], { queryParams: { fromPage: 'CVPC', fromRoute: fromRoute, tripTime: obs.duration_of_vpc, mode: "edit", obsId: obs.id } });
        } else if (obs.type == "HAZ") {
          this.router.navigate(['/vpc-haz'], { queryParams: { fromPage: 'HAZ', fromRoute: fromRoute, tripTime: obs.duration_of_vpc, mode: "edit", obsId: obs.id } });
        }
      }
  }
  closeModal() {
    this.modalController.dismiss({
      click:"back"
    });
  }
  addSelectedObs(element){
    if (this.selectedObslist.indexOf(element) === -1 && element.isChecked) {
      this.selectedObslist.push(element);
    } else if (!element.isChecked) {
      let index = this.selectedObslist.indexOf(element);
      this.selectedObslist.splice(index, 1);
    }
  }
  refreshList()
  {

  }
  addObsList()
  {
    this.modal.dismiss({
      selectedObs: this.selectedObslist,
      click:"ok"
    });
  }
}
